var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoWorkstation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-workstation",
    transform: "translate(-2498 -10298)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 40,
    height: 40,
    transform: "translate(2498 10298)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ico_workstation",
    transform: "translate(2488 10295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_63",
    "data-name": "Trac\\xE9 63",
    d: "M37,8.5A1.5,1.5,0,0,1,38.5,10V37A1.5,1.5,0,0,1,37,38.5H23A1.5,1.5,0,0,1,21.5,37V10A1.5,1.5,0,0,1,23,8.5H37M37,7H23a3,3,0,0,0-3,3V37a3,3,0,0,0,3,3H37a3,3,0,0,0,3-3V10a3,3,0,0,0-3-3Zm-.5,9.25h0a.749.749,0,0,0-.75-.75H24.25a.749.749,0,0,0-.75.75h0a.749.749,0,0,0,.75.75h11.5A.749.749,0,0,0,36.5,16.25Zm0-3h0a.749.749,0,0,0-.75-.75H24.25a.749.749,0,0,0-.75.75h0a.749.749,0,0,0,.75.75h11.5A.749.749,0,0,0,36.5,13.25Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_64",
    "data-name": "Trac\\xE9 64",
    d: "M37.5,54A2.5,2.5,0,1,0,40,56.5,2.5,2.5,0,0,0,37.5,54Zm0,3.5a1,1,0,1,1,1-1A1,1,0,0,1,37.5,57.5Z",
    transform: "translate(-7.5 -23.5)",
    fill: "#646464"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWorkstation);
export default __webpack_public_path__ + "static/media/ico-workstation.e362863373c6e9e342a7429eb9cf20d4.svg";
export { ForwardRef as ReactComponent };